import Login from './Login'

const LoginRouter = {
  path: '/',
  component: Login
}

export default LoginRouter
